import { useElementOnScreen } from '@ice-web-app/shared-hooks';
import { Box, Skeleton, SxProps, Theme } from '@mui/material';
import { FC, MouseEvent, RefObject, useEffect, useState } from 'react';

export interface DsImageProps {
  src?: string;
  imgUrl?: string;
  alt?: string;
  width?: number;
  height?: number;
  loading?: boolean;
  variant?: 'rounded' | 'square' | 'circle';
  ref?: RefObject<HTMLDivElement>;
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
  sx?: SxProps<Theme>;
  skeletonSx?: SxProps<Theme>;
}

export const DsImage: FC<DsImageProps> = ({
  src,
  imgUrl,
  alt,
  width,
  height,
  loading = false,
  variant = 'rounded',
  ref,
  onClick,
  sx,
  skeletonSx,
  ...props
}) => {
  const [imageLoading, setImageLoading] = useState<boolean>(!src);
  const [imageSrc, _setImageSrc] = useState<string | undefined>(src);
  const [elementRef, isVisible] = useElementOnScreen();

  let borderRadius: string;
  switch (variant) {
    case 'rounded':
      borderRadius = '8px';
      break;
    case 'square':
      borderRadius = '0px';
      break;
    case 'circle':
      borderRadius = '50%';
      break;
    default:
      borderRadius = '0px';
  }

  useEffect(() => {
    // if the avatar is exist in the view port
    if (!isVisible || imageSrc) return;

    if (imgUrl) {
      // TODO: Implement
    } else {
      setImageLoading(false);
    }
  }, [src, isVisible, imageSrc, imgUrl]);

  return imageLoading || loading ? (
    <Skeleton
      variant="rounded"
      animation="wave"
      ref={elementRef}
      sx={{
        bgcolor: 'grey.200',
        width: width,
        height: height,
        minWidth: width,
        minHeight: height,
        ...skeletonSx,
      }}
    />
  ) : (
    // <Fade in={!imageLoading || !loading}>
    <>
      <Box
        component="img"
        src={imageSrc}
        alt={alt || ''}
        width={width}
        height={height}
        onClick={onClick}
        ref={ref}
        sx={{
          cursor: onClick ? 'pointer' : 'default',
          objectFit: 'cover',
          borderRadius: borderRadius,
          ...sx,
        }}
        {...props}
      />
    </>
    // </Fade>
  );
};
